// h5页面回到前台显示状态码
export const H5_PAGE_RESUMED_STATE = 1;
// h5页面退到后台显示状态码
export const H5_PAGE_PAUSED_STATE = 2;
// h5页面失去焦点
export const H5_PAGE_INACTIVE_STATE = 3;
// h5页面销毁
export const H5_PAGE_DETACH_STATE = 4;

// 客群类型
// 游客
export const VISITOR_TYPE = 275;
// 自然新人
export const NATURAL_NEWUSER_TYPE = 276;
// 被邀请新人
export const INVITED_NEWUSER_TYPE = 277;
// 引流用户
export const DRAIN_USER_TYPE = 278;
// 跑量用户
export const VOLUME_USER_TYPE = 279;

// 本地存储关闭通知提醒的key
export const MESSAGE_CLOSE_NOTICE_STORAGE_KEY = 'MESSAGE_CLOSE_NOTICE';
